import React, { useState, useEffect, useRef } from 'react';

import { Grid, Typography, Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import WizardLayout from '../../components/WizardLayout';
import AddressSelectBox from '../../components/AddressSelectBox';
import WizardNavigation from '../../components/WizardNavigation';

import { fetchUserData, setAddNewAddress } from '../../redux/user';
import useWizardSteps from '../../hooks/useWizardSteps';

const suggestion = (
  <span>
    <b>Elegí el domicilio</b> que querés asegurar
  </span>
);

export default function SelectAddress() {
  const [active, setActive] = useState('addAddress');
  const dispatch = useDispatch();

  const history = useHistory();
  const { userAddress } = useSelector(({ user }) => ({
    userAddress: user.currentAddress,
  }));

  const totalState = useSelector((state) => state);
  const isFirstRun = useRef(true);

  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected,
  }));
  const { insuranceName } = insuranceSelected || {};
  const [activeStep] = useWizardSteps(insuranceName === 'MASCOTA' ? 3 : 2);

  useEffect(() => {
    if (isFirstRun.current) {
      dispatch(fetchUserData());
      isFirstRun.current = false;
    }
    dispatch(setAddNewAddress(active === 'addAddress'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  return (
    <WizardLayout activeStep={activeStep} suggestion={suggestion}>
      <Grid container item xs={10} spacing={3}>
        <Grid item container xs={12} sm={6}>
          {userAddress && (
            <AddressSelectBox
              active={active === 'currentAddress'}
              setActive={() => setActive('currentAddress')}
            >
              <Typography component='div' fontSize={16}>
                <Box fontWeight='fontWeightBold' m={1}>
                  {userAddress.street}
                </Box>
                <Box m={1}>{userAddress.locality}</Box>
                <Box fontSize={16} m={1}>
                  CP {userAddress.zipCode}
                </Box>
              </Typography>
            </AddressSelectBox>
          )}
        </Grid>
        <Grid item container xs={12} sm={6}>
          <AddressSelectBox
            active={active === 'addAddress'}
            setActive={() => setActive('addAddress')}
            mt={{ xs: '8px', sm: '0px' }}
          >
            <Box fontWeight='fontWeightBold'>
              Quiero asegurar otro domicilio
            </Box>
          </AddressSelectBox>
        </Grid>
        <Grid item container xs={12}>
          <WizardNavigation
            nextAction={() => history.push('/domicilio/nuevo')}
          />
        </Grid>
      </Grid>
    </WizardLayout>
  );
}
